export default function Mission() {
  return (
    <section className="py-24 bg-gradient-to-br from-teal-50 to-cyan-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className="order-2 md:order-1">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="/assets/AboutMission.jpg"
                alt="Our Mission"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>

          <div className="order-1 md:order-2">
            <div className="inline-block bg-teal-600 text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
              OUR MISSION
            </div>
            <h2 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Delivering Quality Healthcare Solutions
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-6">
              Our mission is to improve the quality of life for patients suffering from cardiovascular and diabetic conditions by providing access to safe, effective, and affordable pharmaceutical products.
            </p>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-600 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-heart-pulse-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Patient-Centric Approach</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    We prioritize patient safety and well-being in every decision we make, ensuring our medicines meet the highest quality standards.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-600 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-shield-check-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Quality Assurance</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    We maintain rigorous quality control processes to ensure every product meets international pharmaceutical standards.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-600 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-global-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Global Accessibility</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    We work to make essential cardiac and diabetic medicines accessible to healthcare providers and patients worldwide.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
